import observ from 'observ';
import bus from '../SnackbarBus';
import xtend from 'xtend';

function SlowQueue (emptyState, time) {
    var queue = [];
    var state = observ(emptyState);
    var isRunning = false;

    function startTime () {
        function onTimeEnd () {
            isRunning = false;
            if (!queue.length) {
                state.set(emptyState);
                return;
            }
            startTime();
        }

        if (queue.length && !isRunning) {
            state.set(queue.shift());
            isRunning = true;
            setTimeout(onTimeEnd, time);
        }
    }

    function push (data) {
        queue.push(data);
        if (!isRunning) startTime();
    }

    return {
        state: state,
        push: push
    };
}

function SnackbarStore (bus) {
    var q = SlowQueue({ message: null }, 4000);
    bus.on('snack', q.push.bind(q));
    return q.state;
}

export default SnackbarStore(bus);
